export enum TicketStatus {
  PENDING = "PENDING",
  ASSIGNED = "ASSIGNED",
  RESOLVED = "RESOLVED",
  UNRESOLVED = "UNRESOLVED",
}

// Enum for Priority
export enum Priority {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  URGENT = "URGENT",
  VIP = "VIP",
}

export enum ActionType {
  ASSIGN_USER = "ASSIGN_USER",
  CHANGE_PRIORITY = "CHANGE_PRIORITY",
  ASSIGN_DUEDATE = "ASSIGN_DUEDATE",
  REPLY = "REPLY",
  CHANGE_STATUS = "CHANGE_STATUS",
}

export enum MessageType {
  MEDIA = "MEDIA",
  TEXT = "TEXT",
}

type BinaryData = ArrayBuffer | Uint8Array | Buffer | Blob;

export interface AddTicketModel {
  customerName: string;
  customerEmail: string;
  categoryId: string;
  assignedUserId: string;
  priority: Priority;
  subject: string;
  message: string;
  comment: string;
  files: File | BinaryData | string;
}

export interface TicketCommand {
  ticketStatus: TicketStatus;
  assignUserId: string;
  dueDate: string; // Assuming this is a string representation of a date-time; adjust if needed
  priority: Priority;
}

export interface TicketActionLogDto {
  actionType: ActionType;
  oldValue?: string;
  newValue?: string;
  performedByUserId?: string;
  message: string;
  createdAt?: string; // Assuming this is a string representation of a date-time; adjust if needed
}

export interface TicketReply {
  attachments: string[];
  message: string;
  isRead: boolean;
}

export interface TicketDto {
  id: string;
  createdAt: string; 
  ticketActionLogs?: TicketActionLogDto[] | null;
  status: TicketStatus;
  dueDate: string; 
  referenceId?: string | null;
  customerName: string;
  customerEmail: string;
  categoryName: string;
  categoryId: string; 
  assignedUserId?: string | null;
  priority: Priority;
  subject: string;
  message: string;
  isRead: boolean;
  isChatExist?: true;
  chatId?: string;
  ticketReplies: TicketReply[];
  attachments: string[];
  comment: string;
}

export interface TicketStatistics {
  totalAssigned: number;   // Assuming this is an integer
  resolvedCount: number;   // Assuming this is an integer
  assignedCount: number;   // Assuming this is an integer
}

export interface TicketDtoPaginationResult {
  totalPages: number;      // Assuming this is an integer
  pageSize: number;        // Assuming this is an integer
  pageNumber: number;      // Assuming this is an integer
  totalSize: number;       // Assuming this is an integer
  items?: TicketDto[] | null;  // Assuming TicketDto is the type of items; adjust if needed
}

export interface UpdateBulkTicket {
  tickets: string[];          // Assuming this is an array of UUID strings
  priority: Priority;  // Assuming priority is one of these values
  dueDate: string;            // Assuming this is a string representation of a date-time; adjust if needed
  userToAssign: string;
}


export interface TicketQuery {
  TicketStatus?: string; // Optional query parameter
  CategoryId?: string; // Optional query parameter, assuming this is a UUID string
  SearchKeyword?: string; // Optional query parameter
  Priority?: string; // Optional query parameter, available values
  OrderBy?: string; // Optional query parameter, available values
  Page?: number; // Optional query parameter, integer
  PageSize?: number;
}

export interface AssignSingleTicket {
  ticketId: string;
  ticketStatus: string;
  assignUserId: string;
  dueDate: Date | string;
  priority: string;
}

export interface AssignBulkTicket {
  tickets: string[];
  userToAssign: string;
  dueDate: Date | string;
  priority: string;
}

export interface ReplyTicketModel {
  ticketId: string;
  message?: string;
  messageType: MessageType;
  file?: File | string;
  ReplyFrom: string;
}

export interface UpdateTicketStatus {
  ticketId: string;
  status: TicketStatus;
}

export interface TicketCategoryModel {
  id: string,
  categoryName: string
}

export interface AssignedStatisticsCount {
  totalAssigned: number;
  resolvedCount: number;
  assignedCount: number;
}

export interface AssignedStatusDetails {
  id: string;
  createdAt: string;
  ticketActionLogs: [];
  status: string;
  dueDate: string;
  referenceId: string;
  categoryName: null;
  isRead: boolean;
  ticketReplies: [];
  attachments: null;
  customerName: string;
  customerEmail: string;
  categoryId: string;
  assignedUserId: string;
  priority: string;
  subject: string;
  message: string;
  comment: string;
  files: string;
}

export interface Client {
  jobId: string;
  email: string;
  tenantId: string;
  createdAt: string;
  updatedAt: string;
  id: string;
}

export interface Message {
  messageType: string;
  chatId: string;
  content: string;
  files: string[];
  isSystemGenerated: boolean;
  createdAt: string;
  senderId: Client;
  updatedAt: string;
  id: string;
}

export interface ChatData {
  clientId: Client;
  status: string;
  createdAt: string;
  messages: Message[];
  updatedAt: string;
  id: string;
}